/**
 * design_handoff_auth — split layout, What's new pane on the right.
 * Created by piotr.pozniak@thebeaverhead.com on 20/08/2018.
 */

import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthLayout from "./AuthPages/AuthLayout";
import WhatsNewPane from "./AuthPages/WhatsNewPane";
import LoginEmailForm from "./LoginPage/LoginEmailForm";
import { useUserStore } from "../../../hooks/redux/user";
import AxiosConfig from "./../../../AxiosConfig";

const LoginPage = (props) => {
  const history = useHistory();
  const { user, checkSession } = useUserStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token && token !== "" && !user.checkSession) {
      AxiosConfig.setAuthToken(token);
      checkSession();
      history.replace("/login");
    }
  }, [window.location.search]);

  return (
    <AuthLayout rightPane={<WhatsNewPane />}>
      <LoginEmailForm />
    </AuthLayout>
  );
};

export default LoginPage;
